import {
    Button,
    Card,
    CardContent,
    Typography,
    IconButton,
    Box,
    Grid2,
    Icon,
    TextField,
    Link,
    Paper
} from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useParams } from "react-router-dom";
import { FileTypeEnum } from "../../../_common/enum/fileType.enum";
import { IFilteringViewModel } from "../../../_common/interface/table";
import { StandardButton } from "../../../_components/button/primary.button";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";
import { toastr } from "../../../_components/toastr/toastr";
import { getDate, getDateString } from "../../../_helpers/dateTime.helper";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { clientFollowUpsService } from "../../../_services/clientFollowUp.service";
import { fileUploadService } from "../../../_services/fileUpload.service";

export function ClientUploadsManage() {

    const resetData = () => ({});

    const { id } = useParams<{ id: string }>();
    const [upload, updateUpload] = useState<{ clientId: number | null, fileTypeId: number | null, file: any | null }>({ clientId: 0, fileTypeId: 0, file: null });

    const [data, setData] = useState<any>(resetData);
    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [clientFiles, setClientFiles] = useState<any[]>([]);
    const [filter, setFilter] = useState<IFilteringViewModel>({
        clientId: id,
    });


    useEffect(() => {
        if (id != null) fetchData();
        else setData(resetData);
    }, [id]);


    function fetchData() {
        setIsLoading(true);
        return fileUploadService.getAll(FileTypeEnum.Client, filter)
            .then(
                data => {
                    setClientFiles(data.items);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    }

    function onUploadChange(event: any) {
        const _upload = upload
        _upload.file = event.target.files[0];
        updateUpload({ ..._upload });
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        const formData = new FormData();
        formData.append("file", upload.file);
        formData.append("clientId", (id || 0)?.toString());
        formData.append("fileTypeId", (FileTypeEnum.Client || 0)?.toString());

        return fileUploadService
            .uploadFile(formData)
            .then(
                () => {
                    toastr.success("Client File Upload was successful.");
                    setData(resetData());
                    setShowForm(false);
                    fetchData();
                },
                handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }

    function disable(id: string) {
        if (!id) return;
        setIsLoading(true);

        console.log("disable", id);

        return fileUploadService
            .disable(id)
            .then(
                () => {
                    toastr.success("File deleted successfully");
                    fetchData();
                },
                handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function download(id: string) {
        return fileUploadService.download(id);
    }

    const addNew = () => {
        setData(resetData());
        setShowForm(true);
    };

    const cancel = () => {
        setShowForm(false);
        setData(resetData());
    };

    return (
        <Box p={2}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6"></Typography>
                {!showForm && (
                    <Button variant="contained" onClick={addNew}>
                        Add File
                    </Button>
                )}
            </Box>

            {showForm && (
                <ValidatorForm onSubmit={submit} noValidate>
                    <Grid2 container spacing={2}>
                        <Grid2 size={{ xs: 12 }}>
                            <TextField
                                label="File to Upload"
                                type="file"
                                id="ClientFile"
                                required
                                fullWidth
                                onChange={onUploadChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 6 }}>
                            <StandardButton
                                saving={saving}
                                loading={isLoading}
                                icon="save"
                                type="submit"
                            >
                                Save
                            </StandardButton>
                        </Grid2>
                        <Grid2 size={{ xs: 6 }}>
                            <StandardButton
                                saving={saving}
                                loading={isLoading}
                                icon="block"
                                variant="error"
                                onClick={cancel}>
                                Cancel
                            </StandardButton>
                        </Grid2>
                    </Grid2>
                </ValidatorForm>
            )}

            <Box mt={4}>
                <Box mt={4}>
                    <Grid2 container spacing={2} mt={1}>
                        {clientFiles.map((file, index) => (
                            <Grid2 size={{ xs: 12 }} key={index}>
                                <Paper
                                    elevation={1}
                                    sx={{
                                        p: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        borderRadius: 2,
                                        backgroundColor: '#f9f9f9',
                                        '&:hover': {
                                            backgroundColor: '#f1f1f1',
                                        },
                                    }}
                                >
                                    <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                                        <Typography variant="body1" mr={2}> {file.fileName}</Typography>
                                    </Box>
                                    <IconButton onClick={() => download(file.fileUploadId)} color="primary">
                                        <Icon>download</Icon>
                                    </IconButton>
                                    <IconButton onClick={() => disable(file.fileUploadId)} color="error">
                                        <Icon>delete</Icon>
                                    </IconButton>
                                </Paper>
                            </Grid2>
                        ))}
                    </Grid2>
                </Box>
            </Box>
        </Box>
    );
}
